import { render } from "./SecondaryButton.vue?vue&type=template&id=1adbe34b"
import script from "./SecondaryButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondaryButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/SecondaryButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1adbe34b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1adbe34b', __exports__)) {
    api.reload('1adbe34b', __exports__)
  }
  
  module.hot.accept("./SecondaryButton.vue?vue&type=template&id=1adbe34b", () => {
    api.rerender('1adbe34b', render)
  })

}


export default __exports__